<template>
	<div>
		<!-- 工具栏 -->
		<div style="display: flex; justify-content: space-between;">
			<!-- 搜索 -->
			<div>
				<el-select v-model="projectId" placeholder="请选择项目" style="width: 250px;" size="mini" @change="onChange" filterable>
					<el-option v-for="item in projects" :key="item.code" :label="item.name" :value="item.code">
					</el-option>
				</el-select>
				<!-- <el-button type="primary" icon="el-icon-search" @click="queryFile" style="margin-left: 10px;"
					size="mini">
					搜索
				</el-button> -->
			</div>

			<div :class="title">
				<div>
					<span style="margin-left: 30px;"> 项目ID: {{this.projectId}} </span>
					<span style="margin-left: 30px;"> 项目名称：{{this.projectName}} </span>
				</div>
			</div>
		</div>

		<!-- 九宫图  -->
		<div :class="mainDiv">
			<div class="sudoku_item" v-for="(sudoku,index) in sudokus" :key="index">
				<!-- <el-card :body-style="{ padding: '20px' }"> -->
					<img :src="sudoku.img_src" width="80" height="80" @click="myDeal(index)">
					<div>
						<span>{{sudoku.name}}</span>
						<span style="color: #aa007f; font-size: 30px;" @click="myDelete(index,sudoku.num)">{{sudoku.num}}</span>
						<span>个</span>
					</div>
				<!-- </el-card> -->
				
			</div>
		</div>

		<!-- 弹出框  dialogVisible:是否弹出 -->
		<el-dialog :title="zhuti" :visible.sync="dialogVisible" width="30%">
			<div>
				<!-- 增加一层 el-form表单，可以数据校验 -->
				<el-form ref="inputForm" :model="inputObj" :rules="rules">
					<el-row>
						<el-col :span="24">
							<el-form-item label="项目名称" prop="projectId">
								<el-input type='text' size="mini"  readonly="true"  style="width: 340px;"
									v-model="inputObj.projectName"></el-input>
							</el-form-item>
						</el-col>

					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item label="文档说明" prop="demo">
								<el-input type='textarea' :rows="2" size="mini" prefix-icon="el-icon-edit"
									style="width: 340px;" v-model="inputObj.demo" placeholder="请输入文档说明"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<!--  
					   参考：
					       https://www.jianshu.com/p/f441d2c26191
						   https://blog.csdn.net/weixin_43278947/article/details/85161439
						   https://juejin.cn/post/6844903985401315335
						   
					label-width="100px"
					:on-remove="handleRemove" :on-change="fileChange"
					:before-upload="beforeAvatarUpload" :before-remove="beforeRemove"
					 multiple :file-list="upload.fileList" -->

					<el-row>
						<el-col :span="24">
							<el-form-item label="选择文件" prop="fileName">
								<el-upload ref="upload" :on-remove="handleRemove" :on-change="fileChange"
									:before-upload="beforeAvatarUpload" :before-remove="beforeRemove" multiple
									:file-list="upload.fileList" action="" :auto-upload="false">
									<el-button size="small" type="primary" icon="el-icon-upload2">点击上传</el-button>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>


				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button @click="doChance">取 消</el-button>
				<el-button type="primary" @click="doAddRecord">确 定</el-button>
			</span>
		</el-dialog>
		
		
		<!-- 弹出框  dialogVisible:是否弹出 -->
		<el-dialog title="附件管理" :visible.sync="dialogVisible2" width="50%">
			<div>
				<el-table :data="delListData" stripe  :row-style="{height: '10px'}" :cell-style="{padding: '5px 0'}" size="small"
					 style="width: 100%;height: 100%;">
					<!-- 多选框 -->
					<!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
					<el-table-column prop="id" label="ID"    align="center" width="50">
					</el-table-column>
					<el-table-column prop="fileName" label="文件名称"    align="center" width="200">
					</el-table-column>
					<el-table-column prop="userName" label="创建者"  align="center" width="120">
					</el-table-column>
					<el-table-column prop="createTime" label="上传时间"  align="center" width="200">
					</el-table-column>
					<el-table-column label="操作" align="center"   width="140">
						<template slot-scope="scope">
							<!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
						<!-- 	<el-button type="primary" size="mini" @click="showEditView(scope.row)" >编辑</el-button> -->
							<!-- <el-button type="danger" size="mini" style="padding: 2px">删除</el-button> -->
							<el-button type="danger" @click="deleteRecord(scope.row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="doClose">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<!-- @touchstart="touchstart(index)" @touchend="touchend" -->


<script>
	export default {
		name: 'FileEdit',
		data() {
			return {
				projectId: null,
				fileType: null,
				projectName: null,
				zhuti: null,
				mainDiv: 'sudoku_no',
				title: 'title_no',
				dialogVisible: false,
				dialogVisible2: false,
				projects: [], //项目id-项目名称下拉框
				delListData: [], // 存放删除列表对话框数据
				inputObj: {
					projectId: null,
					fileType: '',
					demo: ''
				},
				sudokus: [{
					id: 0,
					name: '招标文件',
					img_src: require('../../assets/img/b0.png'),
					num: 0
				}, {
					id: 1,
					name: '投标文件',
					img_src: require('../../assets/img/b1.png'),
					num: 0
				}, {
					id: 2,
					name: '中标通知书',
					img_src: require('../../assets/img/b2.png'),
					num: 0
				}, {
					id: 3,
					name: '立项方案',
					img_src: require('../../assets/img/b3.png'),
					num: 0
				}, {
					id: 4,
					name: '采购合同',
					img_src: require('../../assets/img/b4.png'),
					num: 0
				}, {
					id: 5,
					name: '销售合同',
					img_src: require('../../assets/img/b5.png'),
					num: 0
				}, {
					id: 6,
					name: '签收报告',
					img_src: require('../../assets/img/b6.png'),
					num: 0
				}, {
					id: 7,
					name: '需求文档',
					img_src: require('../../assets/img/b7.png'),
					num: 0
				}, {
					id: 8,
					name: '项目方案',
					img_src: require('../../assets/img/b8.png'),
					num: 0
				}, {
					id: 9,
					name: '实施服务方案',
					img_src: require('../../assets/img/b9.png'),
					num: 0
				}, {
					id: 10,
					name: '其它文档',
					img_src: require('../../assets/img/b10.png'),
					num: 0
				}],
				filelist: [],
				curSelect: null,
				// 下面全是文件上传的
				// 非多个禁用   multiple=true 多个文件， multiple=false 单个文件
				multiple: false,
				// 文件下载列表                             
				dataFileList: [],
				// 表单参数
				form: {},
				// 表单校验
				rules: {
					// demo: [{
					// 	required: true,
					// 	message: '请填写文档说明',
					// 	trigger: 'blur'
					// }]
				},
				// 上传参数
				upload: {
					// 是否禁用上传
					isUploading: false,
					// 设置上传的请求头部
					// headers: {Authorization: "Bearer " + getToken()},
					// 上传的地址
					url: '',
					// 上传的文件列表
					fileList: []
				}
			};
		},
		mounted() {
			this.initDim()
		},
		methods: {
			deleteRecord(data) {
				this.$confirm('此操作将永久删除 ' + data.projectName + '的该条上传文件明细, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.postRequest2('/file/delete?id=' + data.id).then(resp => {
						if (resp) {
							this.initDeleteList()
							this.queryFile();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			initDeleteList() {
				this.getRequest('/file/file_list?projectId=' + this.projectId + '&fileType=' + this
					.fileType).then(resp => {
					if (resp) {
						// alert(resp)
						this.delListData = resp
					}
				})
			},
			doClose() {
				this.dialogVisible2 = false
			},
			myDelete(index,num){
				if ( num >0 ) {
					this.fileType = index
					// alert("index="+index)
					this.dialogVisible2 = true
					this.initDeleteList()
				}
			},
			doAddRecord() {
				// 添加文件以及录入的内容
				this.$refs['inputForm'].validate(valid => {
					if (valid) { //验证通过
						let formData = new window.FormData()
						formData.append('fileName', this.upload.fileList[0].raw)
						// 下面 可以添加多个文件
						// this.upload.fileList.forEach(file => {
						// 	formData.append('fileName', file.raw)
						// })
						formData.append("projectId", this.inputObj.projectId)
						formData.append("fileType", this.inputObj.fileType)
						formData.append("demo", this.inputObj.demo)
						formData.forEach(value => console.log(value))
					
						this.postRequest('/file/upload_file', formData).then(resp => {
							if (resp) {
								this.dialogVisible = false
								this.queryFile()
							}
						})
						this.upload.fileList = []
						this.picList = []
						this.dataFileList = []
						this.dialogVisible = false
						this.inputObj.demo = ''
						this.queryFile()

					}
				})
			},
			doChance() {    // 弹出框取消
				this.upload.fileList = []
				this.picList = []
				this.dataFileList = []
				this.dialogVisible = false
				this.inputObj.demo = ''
				this.queryFile()
			},
			onChange(id) { // 通过对象的id 在对象数组中查找对象
				let obj = {}
				obj = this.projects.find(item => {
					return item.code === id
				})
				this.projectName = obj.name
				this.inputObj.projectId = this.projectId
				this.inputObj.projectName = this.projectName
				this.queryFile()
				// alert(obj.name); //获取name
				// alert(JSON.stringify(obj)) // 选择的那一条数据，即item，包含所有的值
			},
			initSet() {
				this.sudokus[0].num = this.filelist[0].num
				this.sudokus[1].num = this.filelist[1].num
				this.sudokus[2].num = this.filelist[2].num
				this.sudokus[3].num = this.filelist[3].num
				this.sudokus[4].num = this.filelist[4].num
				this.sudokus[5].num = this.filelist[5].num
				this.sudokus[6].num = this.filelist[6].num
				this.sudokus[7].num = this.filelist[7].num
				this.sudokus[8].num = this.filelist[8].num
				this.sudokus[9].num = this.filelist[9].num
				this.sudokus[10].num = this.filelist[10].num
			},
			myDeal(index) {
				// alert(index)   // sudokus
				let objk = {}
				objk = this.sudokus.find(item => {
					return item.id === index
				})
				this.zhuti = '上传文件-' + objk.name
				this.dialogVisible = true
				this.inputObj.fileType = index
			},
			queryFile() {
				// this.projectName = this.$refs['xlk'].currentLabels
				this.mainDiv = "sudoku_row" // 开始显示九宫图
				this.title = "sudoku_yes" // 开始显示项目ID 、项目名称
				this.getRequest('/file/pro_num?projectId=' + this.projectId).then(resp => {
					if (resp) {
						this.filelist = resp
						this.initSet()
					}
				})

			},
			initDim() {
				if (!window.sessionStorage.getItem('projects')) {
					this.getRequest('/dim/project').then(resp => {
						if (resp) {
							this.projects = resp.result
							this.saveDictCache('projects', resp.result)
						}
					})
				} else {
					this.projects = this.dictCache('projects')
				}

			},
			/** 文件预上传格式限制 */
			beforeAvatarUpload(file) {
				// const isJPG = file.type === 'image/jpeg'
				// const isPng = file.type === 'image/png'
				// const isLt2M = file.size / 1024 / 1024 < 2
				//
				// if (!isJPG && !isPng) {
				//     this.$message.error('上传图片只能是 JPG或png 格式!')
				// }
				// if (!isLt2M) {
				//     this.$message.error('上传图片大小不能超过 2MB!')
				// }
				// return (isJPG || isPng) && isLt2M
			},
			/** 文件移除时 */
			handleRemove(file, fileList) {
				for (const i in this.picList) {
					if (this.picList[i].key === file.uid) {
						this.picList.splice(i, 1)
					}
				}
				this.upload.fileList = fileList
			},
			// 文件改变时
			fileChange(file, fileList) {
				// this.upload.fileList = fileList  // 上传多个文件
				if (fileList.length > 0) {
					this.upload.fileList = [fileList[fileList.length - 1]] // 这一步，是 展示最后一次选择文件  控制只能一次传一个文件
				}
			},
			// 文件移除之前
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			}
		}
	};
</script>

<style scoped>
	.sudoku_row {
		margin-top: 20px;
		display: flex;
		align-items: center;
		width: 100%;
		flex-wrap: wrap;
	}

	.sudoku_no {
		display: none;
	}

	.title_no {
		display: none;
	}

	.title_yes {
		/* margin-top: 20px; */
		display: flex;
		/* align-items: center; */

	}

	.sudoku_item {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		width: 25%;
		padding-top: 30px;
		padding-bottom: 30px;
		border: 1;
	}

	.opacity {
		opacity: 0.3;
		background: #e5e5e5;
	}

	.sudoku_item img {
		margin-bottom: 3px;
		display: block;
	}

	.upload-demo {
		display: flex;
	}
	
/* 	::v-deep  .el-input__inner {
		border: #dcdfe6 solid;
    	width: 340px;
	    border-top-width: 0px;
	    border-left-width: 0px;
	    border-right-width: 0px;
	    border-bottom-width: 1px;
	} */
	
	.el-input__inner {
		border: #dcdfe6 solid;
		width: 340px;
	    border-top-width: 0px;
	    border-left-width: 0px;
	    border-right-width: 0px;
	    border-bottom-width: 1px;
	}
	
 
</style>
